import React, { useContext } from 'react';

import { AppContext } from '@prisjakt/ui-app-context';

import T from '@prisjakt/ui-translate';
import Rating from '@prisjakt/ui-rating';
import RatingHelper from '@prisjakt/ui-rating/src/rating-helper';
import RatingIcon from '../../../rating/rating-icon';

import * as S from './styles';

import { SmileyType, RatingString } from '../../../rating/types';
import { getSmileyRating } from '../../../rating/utils';

type Props = {
  type?: 'product' | 'store';
  rating?: number | null;
  count?: number | null;
  countTotal?: number | null;
  name?: string;
};

const SummaryRating = ({ type, rating, count, countTotal, name }: Props) => {
  const { t } = useContext(AppContext);
  const rate = rating && RatingHelper.convert(rating, 1);

  const ratingCount = count && count > 500 ? '500+' : count;

  if (type === 'store') {
    const smileyRating = rate && getSmileyRating(rate.real);

    return (
      <S.ShopRating>
        {smileyRating && smileyRating?.iconType ? (
          <S.Rating>
            <RatingIcon
              type={smileyRating.iconType as SmileyType}
              size={S.EMOTICON_SIZE}
              disabled={!count}
            />
          </S.Rating>
        ) : null}

        {count || countTotal ? (
          <>
            {rate && smileyRating && ratingCount && (
              <>
                <S.Score store={type === 'store'}>
                  {rate.roundedString}
                  {smileyRating?.text && (
                    <>
                      <S.Divider />
                      {t('reviews', smileyRating.text as RatingString)}
                    </>
                  )}
                </S.Score>

                <S.Count>
                  {t('reviews', 'rating.n-reviews', {
                    n: ratingCount,
                    count: ratingCount,
                  })}
                </S.Count>
              </>
            )}
          </>
        ) : (
          name && (
            <S.FirstToReviewText>
              <T domain="reviews" name={name}>
                info.first-review.md
              </T>
            </S.FirstToReviewText>
          )
        )}
      </S.ShopRating>
    );
  }

  return (
    <>
      {(count || countTotal) && rate && rate.rounded ? (
        <S.ProductRating>
          <S.Score>{rate.rounded}</S.Score>

          <S.Rating>
            <Rating
              size="large"
              rate={count ? rating : 0}
              count={count}
              showCounter={false}
              secondaryColors={!count}
            />
          </S.Rating>

          {ratingCount ? (
            <S.Count>
              {t('reviews', 'rating.n-reviews', {
                n: ratingCount,
                count: ratingCount,
              })}
            </S.Count>
          ) : null}
        </S.ProductRating>
      ) : (
        name && (
          <S.FirstToReviewText>
            <T domain="reviews" name={name}>
              info.first-review.md
            </T>
          </S.FirstToReviewText>
        )
      )}
    </>
  );
};

export default SummaryRating;
